import { Injectable } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { TakeoverService } from "src/app/takeover/takeover.service";
import { PredefinedUserZone } from "../auth/auth.models";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class TakeoverStatisticsCommon {
	public statisticsTakeoverCount: BehaviorSubject<any>;

	constructor(private authService: AuthService, private takeoverService: TakeoverService) {
		this.statisticsTakeoverCount = new BehaviorSubject<any>(null);
	}

	public takeoverStatisticsCountSubscription: Subscription;
	public computeTakeoverStatisticsCount() {
		if (this.takeoverStatisticsCountSubscription) {
			this.takeoverStatisticsCountSubscription.unsubscribe();
			this.takeoverStatisticsCountSubscription = null;
		}

		this.takeoverStatisticsCountSubscription = this.takeoverService.getTakeoverBadgeStatusObservable().subscribe((rez) => {
			if (rez != null && rez.accounts != null) {
				this.statisticsTakeoverCount.next(rez.accounts.getTakeoverBadgeStatusUsingGET);
			}
		});
	}

	public get toVerifyAccountingCount(): number {
		if (this.statisticsTakeoverCount != null && this.statisticsTakeoverCount.value != null) {
			return this.statisticsTakeoverCount.value.toVerifyAccounting;
		}
	}

	public get toExecuteAccountingCount(): number {
		if (this.statisticsTakeoverCount != null && this.statisticsTakeoverCount.value != null) {
			return this.statisticsTakeoverCount.value.toExecuteAccounting;
		}
	}

	public get toVerifyPayrollCount(): number {
		if (this.statisticsTakeoverCount != null && this.statisticsTakeoverCount.value != null) {
			return this.statisticsTakeoverCount.value.toVerifyPayroll;
		}
	}

	public get toExecutePayrollCount(): number {
		if (this.statisticsTakeoverCount != null && this.statisticsTakeoverCount.value != null) {
			return this.statisticsTakeoverCount.value.toExecutePayroll;
		}
	}

	private get forExpert(): boolean {
		return this.authService.selectedZoneCode === PredefinedUserZone.Expert && this.authService.isInRole('EXPERT');
	}

	private get forHrExpert(): boolean {
		return this.authService.selectedZoneCode === PredefinedUserZone.HrExpert && this.authService.isInRole('HR_EXPERT');
	}

	public get toVerifyCount(): number {
		if (this.forExpert) {
			return this.toVerifyAccountingCount || 0;
		} else if (this.forHrExpert) {
			return this.toVerifyPayrollCount || 0;
		}

		return 0;
	}

	public get toExecuteCount(): number {
		if (this.forExpert) {
			return this.toExecuteAccountingCount || 0;
		} else if (this.forHrExpert) {
			return this.toExecutePayrollCount || 0;
		}

		return 0;
	}

	public get takeoverBadgeCount(): number {
		return (this.toVerifyCount || 0) + (this.toExecuteCount || 0);
	}
}
